var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex el-col-sm-24"},[_c('DateTimePicker',{staticClass:"flex",attrs:{"value":_vm.params.data[_vm.params.colDef.field],"placeholder":_vm.$t('seller.sell.SellModal.StartTime')},on:{"input":_vm.changeDate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }